module.exports = __webpack_public_path__ + "img/tie.0ff4a42e.png";